<script lang="ts">
	import { t, locales, locale } from '$lib/i18n';
	import { setLocale, userLocale } from '../../stores/locale';

	let selectedLocale = $userLocale;

	$: if (selectedLocale !== $locale) {
		userLocale.set(selectedLocale);
		locale.set(selectedLocale);
	}
</script>

<div class="select-wrapper">
	<select bind:value={selectedLocale} on:change={() => setLocale(selectedLocale)} class="minimal">
		{#each $locales as value}
			<option {value}>{$t(`lang.${value.toLowerCase()}`)}</option>
		{/each}
	</select>
</div>

<style lang="postcss">
	select {
		@apply bg-pbg-400 border border-white/5 text-xs text-textpbg-600 rounded-lg;

		display: inline-block;
		padding: 0.6em 3.5em 0.6em 1em;

		/* reset */

		margin: 0;
		-webkit-box-sizing: border-box;
		-moz-box-sizing: border-box;
		box-sizing: border-box;
		-webkit-appearance: none;
		-moz-appearance: none;
	}

	/* arrows */

	select.minimal {
		background-image: linear-gradient(45deg, transparent 50%, gray 50%),
			linear-gradient(135deg, gray 50%, transparent 50%);
		background-position:
			calc(100% - 20px) calc(1em),
			calc(100% - 15px) calc(1em),
			calc(100% - 2.5em) 0.5em;
		background-size:
			5px 5px,
			5px 5px,
			1px 1.5em;
		background-repeat: no-repeat;
	}

	select.minimal:focus {
		background-image: linear-gradient(45deg, transparent 50%, gray 50%),
			linear-gradient(135deg, gray 50%, transparent 50%);
		background-position:
			calc(100% - 20px) calc(1em),
			calc(100% - 15px) calc(1em),
			calc(100% - 2.5em) 0.5em;

		background-size:
			5px 5px,
			5px 5px,
			1px 1.5em;
		background-repeat: no-repeat;

		outline: 0;
	}

	select:-moz-focusring {
		color: transparent;
		text-shadow: 0 0 0 #000;
	}
</style>
